module.exports = __webpack_public_path__ + "static/CHR-8860aa5b06816dcb3c244c29291f9e88.png";